<app-header></app-header>
<app-spinner *ngIf="article == undefined || lang.loading===true"></app-spinner>
<div class="generic-content" *ngIf="lang.loading===false">
  <div class="content">
    <h2><span class="title">{{ article?.title }}</span></h2>
    <div [innerHTML]="article?.text | safeHtml"></div>
  </div>
</div>
